import './Initiatives.css';
import img1 from '../../assets/images/news/news.jpeg';
import img2 from '../../assets/images/news/news1.jpeg';
import img3 from '../../assets/images/news/news2.jpeg';
import img4 from '../../assets/images/news/news5.jpeg';
import img5 from '../../assets/images/news/news6.jpeg';
import img6 from '../../assets/images/news/news7.jpeg';
import citation from '../../assets/images/news/citation.jpeg';
import agroecologyPdf from '../../assets/images/programs/horticulture/agroecology.pdf';

const newsItems = [
  {
    image: img1,
    title: "Showbouy Farms Launches Maiden Awards to Promote Agribusiness",
    link: "https://www.modernghana.com/news/1459342/showbouy-farms-launches-maiden-awards-to-promote.html"
  },
  {
    image: img2,
    title: "Empowering the Next Generation of Farmers in Ghana",
    link: "https://www.modernghana.com/news/1459342/showbouy-farms-launches-maiden-awards-to-promote.html"
  },
  {
    image: img3,
    title: "Youth Leadership in Sustainable Agriculture",
    link: "https://www.modernghana.com/news/1459342/showbouy-farms-launches-maiden-awards-to-promote.html"
  },
  {
    image: img4,
    title: "Innovations in Small-Scale Farming and Agribusiness",
    link: "https://www.modernghana.com/news/1459342/showbouy-farms-launches-maiden-awards-to-promote.html"
  },
  {
    image: img5,
    title: "Community Impact: Building Resilient Food Systems",
    link: "https://www.modernghana.com/news/1459342/showbouy-farms-launches-maiden-awards-to-promote.html"
  },
  {
    image: img6,
    title: "Strategic Partnerships for Agricultural Growth",
    link: "https://www.modernghana.com/news/1459342/showbouy-farms-launches-maiden-awards-to-promote.html"
  },
  {
    image: citation,
    title: "Recognition of Excellence in Agricultural Education",
    link: "https://www.modernghana.com/news/1459342/showbouy-farms-launches-maiden-awards-to-promote.html"
  },
];

const Initiatives = () => {
  return (
    <section className="latest-news py-5">
      <div className="container">
        <div className="latest-news__header text-center mb-5">
          <span className="pill-title">&bull; MEDIA & RESOURCES</span>
          <h2 className="display-4 font-weight-bold" style={{fontFamily: 'Cormorant Garamond, serif'}}>News & Knowledge Hub</h2>
          <p className="lead text-muted">Stay updated with our latest achievements and explore our educational resources.</p>
        </div>

        {/* Featured Resource Card */}
        <div className="featured-resource mb-5">
            <div className="resource-card shadow-lg p-4 p-md-5 d-flex flex-column flex-md-row align-items-center">
                <div className="resource-icon mb-4 mb-md-0 mr-md-5">
                    <i className="fas fa-file-pdf fa-5x text-danger"></i>
                </div>
                <div className="resource-content text-center text-md-left">
                    <h3 className="h2 mb-3" style={{fontFamily: 'Cormorant Garamond, serif'}}>Agroecology Training Guide</h3>
                    <p className="mb-4">Explore our comprehensive guide on sustainable farming practices, soil health, and ecosystem restoration. A vital resource for students and farmers alike.</p>
                    <a href={agroecologyPdf} target="_blank" rel="noopener noreferrer" className="btn btn-custom px-5 py-3">
                        <i className="fas fa-eye mr-2"></i> View Resource & Read More
                    </a>
                </div>
            </div>
        </div>

        {/* News Grid */}
        <div className="latest-news__grid">
          {newsItems.map((item, index) => (
            <article className="news-item" key={index}>
              <div className="news-item__image-wrap">
                <img src={item.image} alt={item.title} className="news-item__image" />
                <div className="news-item__overlay">
                    <a href={item.link} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-custom">Read Article</a>
                </div>
              </div>
              <div className="news-item__body">
                <h3 className="news-item__title">{item.title}</h3>
                <a href={item.link} target="_blank" rel="noopener noreferrer" className="news-item__link">
                  Read More ↗
                </a>
              </div>
            </article>
          ))}
        </div>

        {/* External Link Section */}
        <div className="mt-5 pt-5 text-center border-top">
            <h4 className="mb-3" style={{fontFamily: 'Cormorant Garamond, serif'}}>Read More on Modern Ghana</h4>
            <a href="https://www.modernghana.com/news/1459342/showbouy-farms-launches-maiden-awards-to-promote.html" target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark px-4 py-2">
                Visit Official Press Release <i className="fas fa-external-link-alt ml-2"></i>
            </a>
        </div>
      </div>
    </section>
  );
};

export default Initiatives;
